import React from 'react'

import Dashboard from '../components/Dashboard/Dashboard'

const DashBoardPage = () => {
  return (
    <Dashboard />
  )
}

export default DashBoardPage